import { useRef } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    useIonAlert,
    IonFooter,
    IonGrid,
    IonRow,
    IonCol,
    IonSelect,
    IonSelectOption,
    IonCheckbox,
    IonIcon
} from '@ionic/react';
import { addService, deleteService, setService } from '../firebase/services';
import dateFormat from 'dateformat';
import { checkmark, chevronBack } from 'ionicons/icons';

const ServiceEditor = ({
    onDismiss,
    service
}: {
    onDismiss: () => void,
    service: any
}) => {

    const [presentAlert] = useIonAlert();

    const nameRef = useRef<HTMLIonInputElement>(null);
    const priceRef = useRef<HTMLIonInputElement>(null);
    const therapistPriceRef = useRef<HTMLIonInputElement>(null);
    const timeRef = useRef<HTMLIonSelectElement>(null);
    const groupClassesRef = useRef<HTMLIonCheckboxElement>(null);
    const isNew = service.id === undefined;

    function confirm() {
        //update or create
        const timeValue = Number(timeRef.current?.value);
        const priceValue = Number(priceRef.current?.value ?? 0);
        const therapistPriceValue = parseInt((therapistPriceRef.current?.value as string) ?? '0', 10);
        var data = {
            name: nameRef.current?.value + '',
            time: Number.isFinite(timeValue) ? timeValue : 0,
            price: Number.isFinite(priceValue) ? priceValue : 0,
            therapistPrice: Number.isNaN(therapistPriceValue) ? 0 : therapistPriceValue,
            groupClasses: groupClassesRef.current?.checked ?? false
        }
        if (isNew) {
            addService(data);
        } else {
            setService(data, service.id);
        }
        onDismiss();
    }


    const times = [];
    for (var i = 1; i <= 96; i++) {
        times.push({ key: i * 5, value: dateFormat(new Date((i * 5 - 60) * 60 * 1000), "HH:MM") });
    }


    function remove() {
        presentAlert({
            header: 'Usuwanie!',
            buttons: [
                {
                    text: 'Anuluj',
                    role: 'cancel'
                },
                {
                    text: 'Usuń',
                    role: 'confirm',
                },
            ],
            onDidDismiss: (e: CustomEvent) => {
                if (e.detail.role === 'confirm') {
                    deleteService(service.id);
                    onDismiss();
                }
            },
        })

    }

    function cancel() {
        onDismiss();
    }


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => cancel()}>
                            <IonIcon icon={chevronBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{isNew ? "Tworzenie usługi" : "Edycja usługi " + service.name}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => confirm()}><IonIcon icon={checkmark}/></IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent style={{ height: '100%' }} className="ion-padding">
                <IonItem>
                    <IonLabel position="fixed">Nazwa</IonLabel>
                    <IonInput placeholder="Nazwa" ref={nameRef} value={service.name} ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel position="fixed">Czas</IonLabel>
                    <IonSelect interface="popover" ref={timeRef} value={service.time} placeholder="Czas">
                        {times.map(item => {
                            return <IonSelectOption key={item.key} value={item.key}>{item.value}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel position="fixed">Cena</IonLabel>
                    <IonInput placeholder="Cena" ref={priceRef} value={service.price} type="number" ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel position="fixed">Cena dla terapeuty</IonLabel>
                    <IonInput
                        placeholder="Cena dla terapeuty"
                        ref={therapistPriceRef}
                        value={service.therapistPrice ?? 0}
                        type="number"
                        step="1"
                        inputmode="numeric"
                    ></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel position="fixed">Zajęcia grupowe</IonLabel>
                    <IonCheckbox slot="end" ref={groupClassesRef} checked={service.groupClasses ?? false}></IonCheckbox>
                </IonItem>
            </IonContent>
            <IonFooter>
                {!isNew && service.name === "" ? <div><IonButton size="small" color="danger" onClick={() => remove()}>usuń</IonButton><br/><br/></div> : ""}
            </IonFooter>
        </IonPage>
    );
};

export default ServiceEditor;

